import * as TYPES from 'redux/types';
import {API} from 'config/srm.config';
import {requestInstance, recieveInstance, errorInstance} from './actions';

import {Services} from 'core';

const services = new Services();

const initialState = {request: true};

export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.INSTANCE_REQUEST:
      return {
        ...state,
        request: true,
        error: false,
      };
    case TYPES.INSTANCE_SUCCESS:
      return {
        ...state,
        request: false,
        error: false,
        data: action.payload,
      };
    case TYPES.INSTANCE_MERGE_DATA:
      return {
        ...state,
        data: {
          ...(state.data || {}),
          ...action.payload,
        },
      };
    case TYPES.CLEAR_INSTANCE:
      return {
        request: false,
        error: false,
      };
    case TYPES.INSTANCE_ERROR:
      return {
        ...state,
        request: false,
        error: true,
      };
    default:
      return state;
  }
};

export const fetchInstance = () => (dispatch, _getState) => {
  try {
    dispatch(requestInstance());
    let endPoint = `${API.auth.license}?source=srm`;
    return services.fetchRecords(endPoint, null).then(res => {
      if (res && !res.error) {
        // rop_program / rop_programs / tenant_geo_scope come from the license API.
        dispatch(recieveInstance(res));
        return;
      }
      dispatch(errorInstance(res));
    });
  } catch (err) {
    dispatch(errorInstance(err));
  }
};

export const getInstance = state => state.instance;
